var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 28C0 43.4634 12.5366 56 28 56C43.4634 56 56 43.4634 56 28C56 12.5366 43.4634 0 28 0C12.5366 0 0 12.5366 0 28",
    fill: "#3C5A9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8027 18.6484L35.5327 18.647V14.195C35.0609 14.1348 33.4397 13.999 31.5539 13.999C27.6171 13.999 24.9221 16.3188 24.9221 20.579V24.2498H20.4688V29.2268H24.9221V41.999H30.2477V29.2268H34.6885L35.3535 24.2498H30.2477V21.0718C30.2477 19.6312 30.6621 18.6484 32.8027 18.6484",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.2a0ab12ec7807c3d8c24045dea36fa8c.svg";
export { ForwardRef as ReactComponent };